// extracted by mini-css-extract-plugin
export default {"root":"info-footer-module--root--a97ee","description":"info-footer-module--description--8b914","cta":"info-footer-module--cta--dacb3"};